import React, { ReactElement, useState } from "react";

import { type AutocompleteRenderInputParams } from "@mui/material";

import { useDispatch, useSelector } from "../../store";
import { ReduxFormProps } from "../../types/ReduxForm";
import Autocomplete from "../styled/Autocomplete";
import TextField from "../styled/TextField";

export type SelectorOption = {
  label: string;
  id: string;
};

type SelectorProps = ReduxFormProps & {
  readonly: boolean;
  options: SelectorOption[];
};

const BasicSelector = ({
  getter,
  setter,
  path,
  readonly,
  defaultValue = "",
  options,
}: SelectorProps): ReactElement => {
  const initialValue = useSelector(getter(path, defaultValue));
  const [selected, setSelected] = useState(initialValue);
  const dispatch = useDispatch();
  return (
    <Autocomplete
      fullWidth
      disabled={readonly}
      size="small"
      value={
        options.find((option) => (option as SelectorOption).id === selected) ||
        null
      }
      getOptionLabel={(value) => (value as SelectorOption).label}
      options={options}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField {...params} />
      )}
      onChange={(_event, option: unknown): void => {
        //bug with mui and styled components not knowing the type so have to use unknown
        setSelected((option as SelectorOption)?.id);
        dispatch(setter({ path, value: (option as SelectorOption)?.id }));
      }}
    />
  );
};

export default BasicSelector;
